'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.copyFileWidget = function (copyFileController, pageController) {
	//TODO: make this a section widget and handle stages from the controller here, not directly in HTML
	return mmWidgets.each(this, function () {
		const element = this,
			nameField = element.find('[data-mm-role~="copied-name"]'),
			goButton = element.find('[data-mm-role~="submit"]'),
			editCopy = element.find('[data-mm-role~="editCopy"]');
		let defaultTitle;
		goButton.click(function () {
			const val = nameField.val();
			if (val && val.trim().length) {
				copyFileController.copyTo(val);
			} else {
				nameField.addClass('validation-error');
				nameField.focus();
			}
		});
		pageController.addEventListener('fileLoaded', function (fileId, name) {
			defaultTitle = name;
		});
		pageController.addEventListener('renamed', function (name) {
			defaultTitle = name;
		});
		editCopy.on('click', function () {
			copyFileController.editCopy();
		});
		element.on('show', function () {
			nameField.val('Copy of ' + defaultTitle);
			nameField.removeClass('validation-error');
		});
	});

};
